import {useEffect, useRef, useState} from 'react';
import {useFlujosEstructure} from "hooks/useFlujosEstructure";

import Search from "components/FlujosEstructure/Search";
import Form from "components/FlujosEstructure/Form";
import Table from "components/FlujosEstructure/Table";
import SpinnerBootrap from 'components/SpinnerBootrap';

function FlujosEstructure(){
 const {
    allFlujosEstructure,
    flujosEstructure, 
    loading, 
    page, 
    totalPages, 
    status, 
    deleteFlujoEstructure, 
    updateFlujoEstructure, 
    createFlujoEstructure, 
    getFlujosEstructure, 
    setPage,
    itemsPerPage,
    setItemsPerPage,
} = useFlujosEstructure();

 const [isSearched, setIsSearched] = useState({
     search: '',
     option: '',
     state: false
 })

 const searchFormRef = useRef();
     
 const resetSearch = () => {
    setIsSearched({
        search: '',
        option: '',
        state: false
    })
    searchFormRef.current?.reset();
 }

 useEffect(() => {
    if(status !== 401 ) return
    localStorage.removeItem('token')
    window.location.href="/login"
 }, [status])

 return (
 <div className="container">
     <div className="row my-md-4">
         <h4 className="d-flex justify-content-center">Flujos Estructure</h4>
         <div className="col-12">
             <Search
                getFlujosEstructure={getFlujosEstructure}
                setIsSearched={setIsSearched}
                formRef={searchFormRef}
             />
         </div>
         <div className="col-12">
             <Form createFlujoEstructure={createFlujoEstructure} updateFlujoEstructure={updateFlujoEstructure} setIsSearched={setIsSearched}/>
         </div>
         <div className="col-12">
             {loading && <SpinnerBootrap/>}
             <Table
                allFlujosEstructure={allFlujosEstructure}
                flujosEstructure={flujosEstructure}
                getFlujosEstructure={getFlujosEstructure}
                deleteFlujoEstructure={deleteFlujoEstructure}
                totalPages={totalPages}
                setPage={setPage}
                page={page}
                isSearched={isSearched}
                setIsSearched={setIsSearched}
                hasSearched={isSearched.state}
                itemsPerPage={itemsPerPage}
                setItemsPerPage={setItemsPerPage}
                resetSearch={resetSearch}
             />
         </div>
     </div>
 </div>
 )
}

export default FlujosEstructure